import { render, staticRenderFns } from "./fccImportacaoCandidatos.vue?vue&type=template&id=055667d5"
import script from "./fccImportacaoCandidatos.vue?vue&type=script&lang=js"
export * from "./fccImportacaoCandidatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports